/* Cacao King — reviews UI: card slider (home + collection) and the free pop-up widget.
   Vanilla JS, no libraries. Loaded with defer from layout/theme.liquid. */
(function () {
  'use strict';

  function initReviewCards() {
    var tracks = document.querySelectorAll('[data-ck-review-track]');
    tracks.forEach(function (track) {
      var cards = track.querySelectorAll('[data-ck-review-card]');

      cards.forEach(function (card) {
        var body = card.querySelector('[data-ck-review-body]');
        var moreBtn = card.querySelector('[data-ck-review-more]');
        if (!body || !moreBtn) return;

        // Wait a frame so the line-clamp layout has settled before measuring.
        window.requestAnimationFrame(function () {
          if (body.scrollHeight > body.clientHeight + 2) {
            moreBtn.hidden = false;
            moreBtn.addEventListener('click', function () {
              var expanded = card.classList.toggle('ck-review-card--expanded');
              moreBtn.textContent = expanded ? 'Read less' : 'Read more';
            });
          }
        });
      });

      var slider = track.closest('.ck-review-slider');
      if (!slider) return;
      var prevBtn = slider.querySelector('[data-ck-review-prev]');
      var nextBtn = slider.querySelector('[data-ck-review-next]');

      function stepWidth() {
        var card = track.querySelector('[data-ck-review-card]');
        if (!card) return track.clientWidth;
        var trackStyle = window.getComputedStyle(track);
        var gap = parseFloat(trackStyle.columnGap || trackStyle.gap || '0') || 0;
        return card.getBoundingClientRect().width + gap;
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          track.scrollBy({ left: -stepWidth(), behavior: 'smooth' });
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          track.scrollBy({ left: stepWidth(), behavior: 'smooth' });
        });
      }
    });
  }

  function sessionGet(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function sessionSet(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (e) {
      /* private mode / blocked storage — degrade silently, popup just won't remember */
    }
  }

  function initPopupReviews() {
    var root = document.getElementById('ck-popup-review');
    var dataEl = document.getElementById('ck-popup-review-data');
    if (!root || !dataEl) return;

    var path = window.location.pathname || '';
    if (path.indexOf('/cart') === 0 || path.indexOf('/checkout') === 0) return;
    if (sessionGet('ckReviewPopupClosed') === '1') return;

    var reviews;
    try {
      reviews = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    if (!reviews || !reviews.length) return;

    var reduceMotion = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Shuffle so repeat visitors in the same session don't always see the same order.
    var order = reviews.slice();
    for (var i = order.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = order[i];
      order[i] = order[j];
      order[j] = tmp;
    }

    var maxShows = 4;
    var shown = 0;
    var idx = 0;
    var intervalId = null;

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str == null ? '' : String(str);
      return div.innerHTML;
    }

    function render(review) {
      var stars = '';
      for (var s = 1; s <= 5; s++) {
        stars += '<span class="ck-star' + (s <= review.rating ? '' : ' ck-star--empty') + '">★</span>';
      }
      var verifiedHtml = review.verified
        ? ' · <span class="ck-popup-review__verified">Verified buyer</span>'
        : '';
      root.innerHTML =
        '<button type="button" class="ck-popup-review__close" aria-label="Close">&times;</button>' +
        '<div class="ck-popup-review__stars" aria-hidden="true">' + stars + '</div>' +
        '<p class="ck-popup-review__quote">“' + escapeHtml(review.short) + '”</p>' +
        '<p class="ck-popup-review__who">' + escapeHtml(review.name) + verifiedHtml + '</p>';

      var closeBtn = root.querySelector('.ck-popup-review__close');
      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          hide();
          sessionSet('ckReviewPopupClosed', '1');
          if (intervalId) window.clearInterval(intervalId);
        });
      }
    }

    function show() {
      if (shown >= maxShows) return;
      render(order[idx % order.length]);
      idx++;
      shown++;
      root.hidden = false;
      window.requestAnimationFrame(function () {
        root.classList.add('ck-popup-review--visible');
      });
      if (shown >= maxShows) {
        // Let the last one sit for a while, then tidy up.
        window.setTimeout(hide, 10000);
      }
    }

    function hide() {
      root.classList.remove('ck-popup-review--visible');
      window.setTimeout(function () {
        root.hidden = true;
      }, reduceMotion ? 0 : 300);
    }

    window.setTimeout(function () {
      show();
      intervalId = window.setInterval(function () {
        if (shown >= maxShows) {
          window.clearInterval(intervalId);
          return;
        }
        show();
      }, 20000);
    }, 12000);
  }

  function init() {
    initReviewCards();
    initPopupReviews();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
